"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var constants_1 = require("./constants");

var N3 = require('n3');

var DataFactory = N3.DataFactory;
var namedNode = DataFactory.namedNode;

function getURIData(uri, model, prefixes) {
  var name = '';
  var prefixName = '';
  var prefix = '';
  var url = '';
  var urlTarget = '';

  for (var _i = 0, _a = Object.keys(prefixes); _i < _a.length; _i++) {
    var key = _a[_i];

    if (uri.includes(prefixes[key])) {
      prefix = key;
      name = uri.replace(prefixes[key], '');
      prefixName = prefix + ":" + name;
      url = constants_1.DefaultPrefixes[prefix] ? "" + prefixes[key] + name : "#" + name;
      urlTarget = constants_1.DefaultPrefixes[prefix] ? '_blank' : '_self';
      break;
    }
  }

  var commentQuad = model.getQuads(namedNode(uri), namedNode(prefixes.rdfs + "comment"), null, null)[0];
  var comment = commentQuad ? commentQuad.object.id.substring(1, commentQuad.object.id.length - 1) : '';
  var labelQuad = model.getQuads(namedNode(uri), namedNode(prefixes.rdfs + "label"), null, null)[0];
  var label = labelQuad ? labelQuad.object.id.substring(1, labelQuad.object.id.length - 1) : '';
  return {
    comment: comment,
    label: label,
    name: name,
    prefixName: prefixName,
    prefix: prefix,
    url: url,
    urlTarget: urlTarget
  };
}

exports.getURIData = getURIData;

function getElement(uri, model, prefixes) {
  return tslib_1.__assign(tslib_1.__assign({}, getURIData(uri, model, prefixes)), {
    uri: uri
  });
}

exports.getElement = getElement;

function getPrefixList(prefixes) {
  return Object.keys(prefixes).map(function (prefix) {
    return {
      prefix: prefix,
      uri: prefixes[prefix]
    };
  });
}

exports.getPrefixList = getPrefixList;